"use strict";
(self["webpackChunkheraclea_olive_oil"] = self["webpackChunkheraclea_olive_oil"] || []).push([[714],{

/***/ 317:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ debounce)
/* harmony export */ });

/**
 * Debounce
 * @param {*} callback 
 * @param {*} wait 
 * @returns 
 */

function debounce(callback, wait = 200) {
  let timeoutId = null

  return (...args) => {
    window.clearTimeout(timeoutId)

    timeoutId = window.setTimeout(() => {
      callback.apply(this, args)
    }, wait)
  }
}

/***/ }),

/***/ 685:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ menuMobile)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(880);
/* harmony import */ var _on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(317);
// components/menu.js





function menuMobile({ wrapper }) {
  const { classes } = window.config

  // Cache finds the triggers based on what is set to toggle the wrapper
  const cache = {
    links: wrapper.querySelectorAll('[data-hook="menu-link-mobile"]'),
    cards: wrapper.querySelectorAll('[data-hook="menu-link"] [data-hook="menu-card"]'),
    clickToggle: document.querySelector('[data-utility="click-toggle"][data-toggle="[id$=header-mega-menu] nav"]'),
  }

  // Init Menu
  ;(function init() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).onClassChange(classes.active, toggle)

    const resizeHandlerDebounced = (0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(resizeHandler, 300)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('resize', resizeHandlerDebounced)
  })()

  function toggleScroll({ lock }) {
    if (lock) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }

  // Popup Events
  function toggle(hasClass) {
    if (hasClass) {
      open()
      toggleScroll({ lock: true })
      setTimeout(() => {
        window.addEventListener('click', clickOutsideHandler)
      }, 0)
    } else {
      close()
      toggleScroll({ lock: false })
    }
  }

  function open() {
    const timeline = gsap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.timeline()

    timeline.set(cache.links, { opacity: 0, autoAlpha: 0 })

    timeline
      .set(wrapper, {
        opacity: 0,
        autoAlpha: 0,
        transformOrigin: 'top',
        scaleY: 0,
      })
      .set(wrapper, {
        display: 'block',
      })
      .to(wrapper, {
        opacity: 1,
        autoAlpha: 1,
        scaleY: 1,
        duration: 0.3,
        ease: 'power1.in',
      })
      .to(
        cache.links,
        {
          opacity: 1,
          autoAlpha: 1,
          duration: 0.15,
        },
        '0.3'
      )
      .set(wrapper, {
        translateY: '100%',
      })
  }

  function close() {
    const timeline = gsap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.timeline()

    timeline
      .to(cache.links, { opacity: 0, duration: 0.15 })
      .to(
        wrapper,
        {
          duration: 0.075,
          opacity: 0,
          scaleY: 0,
          ease: 'power1.in',
        },
        '0.15'
      )
      .set(wrapper, {
        display: 'none',
        opacity: 1,
        scaleY: 1,
      })
      .call(() => {
        const event = new Event('menu-mobile:close')
        wrapper.dispatchEvent(event)
      })
  }

  function removeStyleAttribute() {
    // wait a bit before resetting
    setTimeout(() => {
      wrapper.removeAttribute('style')
      wrapper.removeEventListener('menu-mobile:close', removeStyleAttribute)
    }, 50)
  }

  function resizeHandler() {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches

    if (isDesktop && wrapper.classList.contains(classes.active)) {
      // get for click-toggle trigger (menu button) & click to close
      cache.clickToggle.click()
      wrapper.addEventListener('menu-mobile:close', removeStyleAttribute)
    }
  }

  // For better UX, close mobile nav on click outside of nav
  function clickOutsideHandler(event) {
    if (
      event.target === wrapper ||
      wrapper.contains(event.target) ||
      event.target === cache.clickToggle ||
      cache.clickToggle.contains(event.target)
    ) {
      return
    }

    cache.clickToggle.click()
    window.removeEventListener('click', clickOutsideHandler)
  }
}


/***/ })

}]);